<template>
  <div class="c-container__body">
    <div class="o-row o-row-tiny c-container__grown-child">
      <div class="o-layout">
        <div v-if="judge" class="o-layout__item u-margin-top-medium">
          <h3
            class="c-title c-title--event u-1-of-1 u-push-1-of-5-at-small u-3-of-5-at-small u-padding-left-medium u-margin-bottom-none">
            {{ getPanelName() }} <br/>
            {{judge.lastName}} {{judge.firstname}}
          </h3>
        </div>
        <div v-if="positions" class="o-layout__item u-margin-top-medium">
          <h3 v-for="p of positions" :key="p.position"
            class="c-title c-title--event u-1-of-1 u-push-1-of-5-at-small u-3-of-5-at-small u-padding-left-medium u-margin-bottom-none">
            {{ p.name }}
          </h3>
        </div>
        <div class="o-layout__item u-margin-top-medium">
          <h3
            class="c-title c-title--event u-1-of-1 u-push-1-of-5-at-small u-3-of-5-at-small u-padding-left-medium u-margin-bottom-none">
            {{ $t('panel.idleMessage') }}
          </h3>
        </div>
      </div>
    </div>

    <template
      v-if="showPreviousExercise &&exercise && exercise.id === panel.previousExerciseId && exercise.status === 'finished'">
      <div class="o-row o-row-tiny">
        <div class="o-layout">
          <h3
            class="c-title c-title--event u-1-of-1 u-push-1-of-5-at-small u-3-of-5-at-small u-padding-left-medium u-margin-bottom-none">
            {{ $t('panel.previousResult') }}</h3>
        </div>
      </div>
      <div class="o-row o-row-tiny">
        <exercise
          :blockParticipation="getDummyBlockPart()"
          :exerciseTypeId="exercise.exerciseTypeId" :panelId="panel.id"
          :pass="0" :noedit="true"/>

      </div>
    </template>
  </div>
</template>

<script>
import find from 'lodash/find'
import panelHandler from "@/lib/panelHandler"

export default {
  name: "idle",
  components: {
    exercise: require('client/components/models/blockExercise.vue').default,
  },
  data: function () {
    return {
      participation: undefined,
      showPreviousExercise: false,
    };
  },
  computed: {
    exercise: function () {
      return this.$store.state.exercise.exercise;
    },
    panel: function () {
      return find(this.$store.state.panels.items, i => i.id === this.$route.params.panelId)
    },
    judge: function() {
      const member = find(this.panel.members, i => i.id === this.$route.params.panelMemberId)
      return find(this.$store.state.members.items, i => i.id === member.judgeId )
    },
    positions: function() {
      const positions = panelHandler.calculatePositions(this.panel)
      const member = find(this.panel.members, i => i.id === this.$route.params.panelMemberId)
      return positions.filter(p => member.positions.includes(p.position))
    },
  },
  created: function () {
    const eventDiscipline = find(this.$store.state.eventDisciplines.items, i => i.id === this.panel.eventDisciplineId)

    this.showPreviousExercise = !eventDiscipline.judgesHideScores
  },
  methods: {
    getDummyBlockPart: function () {
      return {
        participationId: this.exercise.participationId,
      }
    },
    getPanelName: function() {
      return panelHandler.panelName(this.panel)
    },
  },
};
</script>
